module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACMSURBVHgB7ZO7DYAgEEAPYlhAGzscxS2wcTZDg1s4inRWLmCDoSMG4fiUvPbgPSABoNEohfwN7nU5DQAHnET3Uk2+GYUKhA5CIINLCM4YOVzxIJXXlXwDV26fJrY+KfCVP9TMsT3ogE8+bruO7UMFcuWoQIk8GiiVBwM15MFADbmlCw0xcsxfaDTKeAF5u1IClyxpQAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/red-arrow.png
// module id = 386
// module chunks = 0